import styled from 'styled-components'

export const HeaderLayout = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  flex-direction: column-reverse;
  display: flex;
  transition: all 0.2s ease;

  transform: ${({ $scroll }) => ($scroll ? `translateY(-100%)` : `none`)};
`
